import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useSidebar } from '../../../context/SidebarContext';

const SidebarToggle = ({ className = '' }) => {
  const { isCollapsed, toggleSidebar } = useSidebar();

  return (
    <button
      onClick={toggleSidebar}
      className={`sidebar-toggle-btn ${className}`}
      style={{
        background: 'transparent',
        border: 'none',
        fontSize: '18px',
        color: '#333',
        cursor: 'pointer',
        padding: '8px 12px',
        borderRadius: '4px',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = 'rgba(0,0,0,0.1)';
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = 'transparent';
      }}
      aria-label="Toggle Sidebar"
    >
      <FontAwesomeIcon 
        icon={isCollapsed ? faBars : faTimes} 
        style={{ 
          transition: 'transform 0.2s ease',
          transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)'
        }}
      />
    </button>
  );
};

export default SidebarToggle; 